/**
 * Close Icon Component (X)
 */

interface CloseIconProps {
  readonly className?: string
}

export default function CloseIcon({ className = 'w-6 h-6' }: CloseIconProps) {
  return (
    <svg
      className={className}
      fill='none'
      stroke='currentColor'
      viewBox='0 0 24 24'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  )
}
